import React, { useEffect, useState } from "react";
// import Tabs from './tabs';
import "./css.css";
import img1 from "../img/TU_1D.png";
import img2 from "../img/TU_1M.png";
import img3 from "../img/TU_1Y.png";
import { useNavigate } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Button from "react-bootstrap/Button";
// import Form from "react-bootstrap/Form";
import { db } from "../config_firebase";
import * as Yup from "yup";
import { Formik, Field, Form } from "formik";
import { Form as Form1 } from "react-bootstrap";

import {
  collection,
  addDoc,
  getDocs,
  doc,
} from "firebase/firestore";

/**
 * @author
 * @function
 **/

export const Page0 = (props) => {
  const [pic, setPic] = useState(img1);
  const [estimation, setConfidence] = useState(true);
  const history = useNavigate();
  const [url, setUrl] = useState(window.location.href);
  const [userId, setUserId] = useState("");
  const [key, setKey] = useState('page0_1D');
  const [selectedValue, setSelectedValue] = useState(50);
  const [isRangeMoved, setIsRangeMoved] = useState(false);

  const handleRangeChange = (event) => {
    setSelectedValue(event.target.value);
  };

  async function addclick(data) {
    console.log(data);
    const docRef = await addDoc(collection(db, "clicksdata"), {data,});
  }

  const submit = async () => {
    console.log(selectedValue);
    localStorage.setItem("page0_confidence",selectedValue);
    const page0_confidence_button = {
      time: Date.now(),
      userId: localStorage.getItem("user_id"),
      buttonType: "page0_confidence_button",
    };
    history(`/page0A/?,${userId}`);
    addclick(page0_confidence_button);
  }

  const button = async (eventKey) => { 
    setKey(eventKey)
    const clickdata = {
      time: Date.now(),
      userId: localStorage.getItem("user_id"),
      buttonType: eventKey
    };
    addclick(clickdata);
    if (eventKey === "page0_1D") {
      setPic(img1);
    }
    if (eventKey === "page0_1M") {
      setPic(img2);
    }
    if (eventKey === "page0_1Y") {
      setPic(img3);
    }
  }  

  useEffect(() => {
    const iosa = url.split(",");
    setUserId(iosa[1]);
  }, []);

  return (
    <div className="main">
      <div className="header">
        <h1>CORPORATION Y</h1>
        <h3>Current Price: 7.29 USD</h3>
      </div>
      <div className="grid">
        <div className="webtabs">
          <Tabs
            defaultActiveKey="profile" id="uncontrolled-tab-example" className="mb-3" activeKey={key}
            onSelect={(e) => button(e)}
          >
            <Tab eventKey="page0_1D" title="1D">
              <img className="img" src={pic} alt="" />
            </Tab>
            <Tab eventKey="page0_1M" title="1M">
              <img className="img" src={pic} alt="" />
            </Tab>
            <Tab eventKey="page0_1Y" title="1Y">
              <img className="img" src={pic} alt="" />
            </Tab>
            <Tab eventKey="page0_details" title="Details">
              {/* <img className="img1" src={pic} alt="" /> */}
              <table class="table table-hover table-dark table-striped">
                <tbody>
                  <tr>
                    <th scope="row"></th>
                    <td>Open</td>
                    <td>7.32</td>
                    <td>Beta</td>
                    <td>1.19</td>
                  </tr>
                  <tr>
                    <th scope="row"></th>
                    <td>High</td>
                    <td>7.37</td>
                    <td>Avg Volume</td>
                    <td>479426.67</td>
                  </tr>
                  <tr>
                    <th scope="row"></th>
                    <td>Low</td>
                    <td>7.29</td>
                    <td>Market Cap</td>
                    <td>2107493.98</td>
                  </tr>
                  <tr>
                    <th scope="row"></th>
                    <td>Close</td>
                    <td>7.29</td>
                    <td>52 Week High</td>
                    <td>8.1</td>
                  </tr>
                  <tr>
                    <th scope="row"></th>
                    <td>Adj Close</td>
                    <td>4.17</td>
                    <td>52 Week Low</td>
                    <td>5.61</td>
                  </tr>
                  <tr>
                    <th scope="row"></th>
                    <td>Volume</td>
                    <td>203200</td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </Tab>
            <Tab eventKey="page0_profile" title="Profile">
              {/* <img className="img" src={pic} alt="" /> */}
              <p className="profileinfo"> Sector: Communication Services <br></br><br></br>
                This corporation offers diverse and innovative technology solutions to enhance both personal and business communication needs.<br></br>
                It operates in the telecommunications and information technology industry and divided into two segments <br></br>
                of technological solutions and costumer experience.  <br></br>
                The corporation provides a comprehensive range of products and services including telecommunications,<br></br>
                network, mobile, data, television, hosting, cloud-based, and security solutions, <br></br>
                as well as software, data analytics, and healthcare technology. <br></br>
                The corporation specializes in digital customer experience and transformation solutions, <br></br>
                leveraging artificial intelligence and content management technologies.<br></br>
              </p>
            </Tab>
          </Tabs>
        </div>
        <div className="info">

        {estimation ? (
            <div class="text-center">
              <div>
                <h1>YOUR INITIAL PREDICTION</h1>
                <p>Based on the information available, what is your prediction of the stock's price, in $, exactly one month later?
                </p>
              </div>
              <Formik
                initialValues={{ page0_prediction: "" }}
                onSubmit={(values) => {
                  console.log(values.page0_prediction);
                  localStorage.setItem("page0_prediction", values.page0_prediction);
                  const page0_prediction_button = {
                    time: Date.now(),
                    userId: localStorage.getItem("user_id"),
                    buttonType: "page0_prediction_button"
                  };
                  addclick(page0_prediction_button);
                  setConfidence(false);
                }}
                validationSchema={Yup.object({
                  page0_prediction: Yup.number().max(10000).min(0).required("prediction is required")
                })}
              >
                {(formik, isSubmitting) => (
                  <Form>
                    <div className="d-flex justify-content-center">
                      <div className="col-sm-4">
                        <Field name="page0_prediction" className={ formik.touched.page0_prediction && formik.errors.page0_prediction ? "form-control is-invalid" : "form-control" } type="text" placeholder="numbers only"/>
                      </div>
                    </div>
                    <br></br>
                    <div class="text-center">
                      <Button variant="dark" className="estbutton" type="submit">Submit</Button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          ) : (
            <div class="text-center">
              <div>
                <h1>YOUR CONFIDENCE LEVEL</h1>
                <p> Please move the marker to indicate how confident you are that your prediction is accurate, from 0 to 100. 
                  <span className="marker_span"><br></br>0- I am definitely wrong.
                  100- I am definitely right. </span><br></br>
                </p>
              </div>
              <Form1.Range name="page0_confidence" value={selectedValue} onChange={handleRangeChange} onInput={() => setIsRangeMoved(true)}/>
              <p>Confidence level: {isRangeMoved ? selectedValue : "none"}</p>
              <Button variant="dark" className="estbutton" type="submit" onClick={submit} disabled={!isRangeMoved}>Submit</Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
